import CreateIcon from "../../Icons/Create";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";

import loadable from "@loadable/component";
const CreateOrderComponent = loadable(
  () => import("../../components/Order/CreateOrder")
);
const CreateOrder = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["order"],
    navigateURL: "/order",
  });

  const { data:defaultBranch, isLoading } = useGetHook({
    queryKey: [`default-branch`],
    url: `${APIS.DEFAULT_BRANCH}`,
    params: {},
  });

  const handleCreate = async (values: any, setError: any) => {
    console.log(values)
    const url = `${APIS.ORDER}`;
    let formData = {
      ...values
    }
    try {
      const res = await mutateAsync({ url, formData });
      console.log(res, "response");
    } catch (err) {
      console.log(err);
    }
  };

  const { mutateAsync: createCustomerMutateAsync, isPostLoading: createCustomerLoading } = usePostHook({
    queryKey: ["customers"],
    navigateURL: "/customer",
  });

  const handleCreateCustomer = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}`;
    let formData = {
      ...values,
      "mobile_number": `+977${values?.mobile_number}`,
      "secondary_contact": values?.secondary_contact ? `+977${values?.secondary_contact}` : `+977${values?.mobile_number}`
    };
    try {
      await createCustomerMutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Consignment</span>
      </div>
      {isLoading?<Spinner/>:
      <CreateOrderComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
        handleCreateCustomer={handleCreateCustomer}
        createCustomerLoading={createCustomerLoading}
        defaultBranch={defaultBranch}
      />
    }

    </>
  );
};

export default CreateOrder;
